// src/pages/AwardView.jsx

import React from 'react';
import styled from 'styled-components';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PublicAPI } from '../api/public';
import { renderTextWithLineBreaks } from '../utils/textHelpers';

const Page = styled.main`padding:22px 0;`;
const Container = styled.div`width:min(1400px,96vw); margin:0 auto; padding:0 18px; display:grid; gap:16px;`;
const Card = styled.div`
  border:1px solid var(--bdr); border-radius:14px; background:var(--card); box-shadow:var(--shadow);
  padding:16px; display:grid; gap:14px;
  .head{ display:flex; gap:16px; align-items:flex-start; flex-wrap:wrap; }
  img{ width:200px; height:140px; object-fit:contain; background:#fafafa; border-radius:10px; border:1px solid var(--bdr); }
  h1{ margin:0; font-size:28px; }
  .meta{ opacity:.8; display:flex; gap:10px; flex-wrap:wrap; }
  .desc{ white-space:pre-wrap; }
`;

export default function AwardView(){
  const { id } = useParams();
  const { i18n } = useTranslation();
  const [item, setItem] = React.useState(null);
  const [err, setErr] = React.useState('');

  React.useEffect(()=>{
    let stop = false;
    (async()=>{
      setErr('');
      try{
        const res = await PublicAPI.award(id, { locale: i18n.language || 'ru' });
        if (!stop) setItem(res?.award || res || null);
      }catch(e){
        if (!stop) { setItem(null); setErr(e?.message || 'Not found'); }
      }
    })();
    return ()=>{ stop = true; };
  }, [id, i18n.language]);

  if (err) {
    return (
      <Page>
        <Container>
          <p style={{color:'#c62828'}}>{err}</p>
          <Link className="btn" to="/awards">← Ко всем наградам</Link>
        </Container>
      </Page>
    );
  }

  if (!item) {
    return (
      <Page><Container><div style={{opacity:.7}}>Загрузка…</div></Container></Page>
    );
  }

  return (
    <Page>
      <Container>
        <Link className="btn" to="/awards">← Ко всем наградам</Link>
        <Card>
          <div className="head">
            {(item.image_thumb || item.image) && (
              <img src={item.image_thumb || item.image} alt={item.title} />
            )}
            <div>
              <h1>{item.title}</h1>
              <div className="meta">
                {item.organization && <span>{item.organization}</span>}
                {item.category && <span>#{item.category}</span>}
                {item.year && <span>{item.year}</span>}
              </div>
            </div>
          </div>
          {item.description && (
            <div 
              className="desc"
              dangerouslySetInnerHTML={renderTextWithLineBreaks(item.description, true)}
            />
          )}
        </Card>
      </Container>
    </Page>
  );
}
